import { NotifyData } from '#/services/NotificationService';
import axios from './axios';
import { API } from '#/config/api';
import { PagenateData } from '#/components/parts/Pagenate';
import { UserItem } from './UserService';
import dayjs from 'dayjs';

export interface DeviceSensor {
  identifier: string;
  volt: number;
  battery: number;
  receive_at: string;
  temperture: number;
  humidity: number;
  radio: number;
}

export interface DeviceLocation {
  lat: number;
  lon: number;
}

export interface DeviceItem {
  id: number;
  type: string;
  device_id: string;
  name: string;
  location: DeviceLocation;
  notify: NotifyData;
  created_at: string;
  updated_at: string;
  installed_at: string;
  owner_id: string;
  admin_id: string;
  device_count: number;
  volt_limit?: number;
  sensor?: Partial<DeviceSensor>;
}

export interface DeviceData {
  page: PagenateData;
  data: DeviceItem[];
}

class DeviceService {
  private device_type: string;
  private loginedUser: UserItem;

  constructor(device_type: string, loginedUser: UserItem) {
    this.device_type = device_type;
    this.loginedUser = loginedUser;
  }

  /**
   * デバイス一覧の取得
   *
   */
  public async getList(query: { [key: string]: any }) {
    const res = await axios.get(API.DeviceEndpoint, {
      params: {
        ...query,
        device_type: this.device_type,
      },
      headers: {
        Token: this.loginedUser.token,
      },
    });

    return res.data;
  }

  /**
   * デバイスの登録
   *
   */
  public async addDevice(data: Partial<DeviceItem>) {
    const res = await axios.post(
      API.DeviceTypeEndpoint(this.device_type),
      {
        ...data,
      },
      {
        headers: {
          Token: this.loginedUser.token,
        },
      }
    );

    return res.data;
  }

  /**
   * デバイス詳細の取得
   *
   */
  public async getInfo(id: string) {
    const res = await axios.get(API.DeviceInfoEndpoint(id), {
      params: {
        kind: this.device_type,
      },
      headers: {
        Token: this.loginedUser.token,
      },
    });

    return res.data;
  }

  /**
   * デバイスの更新
   *
   */
  public async modifyDevice(data: Partial<DeviceItem>) {
    const res = await axios.put(
      API.DeviceTypeEndpoint(this.device_type),
      {
        ...data,
      },
      {
        headers: {
          Token: this.loginedUser.token,
        },
      }
    );

    return res.data;
  }

  /**
   * デバイス詳細のセンサーデータを取得
   *
   */
  public async getSensor(id: string, begin: dayjs.Dayjs, end: dayjs.Dayjs) {
    const res = await axios.get(API.DeviceSensorEndpoint(id), {
      params: {
        from: begin.format('YYYY-MM-DD HH:00:00'),
        to: end.format('YYYY-MM-DD HH:00:00'),
        kind: 'child',
      },
      headers: {
        token: this.loginedUser.token,
      },
    });

    return res.data;
  }
}

export default DeviceService;
